import * as yup from "yup";
import { passwordValidator } from "validators/commonValidators";

export const signInValidator = yup.object({
  username: yup.string().required("Username is required"),
  password: passwordValidator,
});
